import type { NavItem } from '../types/nav';

export const navItems: NavItem[] = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    icon: 'LayoutDashboard',
    roles: ['SuperAdmin'],
  },
  {
    name: 'Companies',
    path: '/dashboard/companies',
    icon: 'Building2',
    roles: ['SuperAdmin'],
  },
  {
    name: 'Users',
    path: '/dashboard/users',
    icon: 'Users',
    roles: ['SuperAdmin', 'CompanyAdmin'],
  },
  {
    name: 'Wells',
    path: '/dashboard/wells',
    icon: 'Droplets',
    roles: ['SuperAdmin', 'CompanyAdmin', 'CompanyUser'],
  },
  {
    name: 'Surface Locations',
    path: '/dashboard/sites',
    icon: 'MapPin',
    roles: ['SuperAdmin'],
  },
  {
    name: 'Annotations',
    path: '/dashboard/annotations',
    icon: 'StickyNote',
    roles: ['SuperAdmin'],
  },
  {
    name: 'Tool Models',
    path: '/dashboard/tool-models',
    icon: 'Wrench',
    roles: ['SuperAdmin'],
  },
  {
    name: 'Tool Inventory',
    path: '/dashboard/inventory',
    icon: 'Package',
    roles: ['SuperAdmin'],
  },
  {
    name: '3D Models',
    path: '/dashboard/3d-models',
    icon: 'Box',
    roles: ['SuperAdmin'],
  },
  {
    name: 'Change Password',
    path: '/dashboard/change-password',
    icon: 'KeyRound',
    roles: ['SuperAdmin', 'CompanyAdmin', 'CompanyUser'],
  },
];
